

























































































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getIndexFromList,
    isNullOrEmpty
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import Input from '../../core/components/Input.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import { SlotTypes } from '../utils';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        LoadingDialog,
        PlusEyeButtons,
        Breadcrums,
        CloseConfirmationModal,
        Input
    }
})
export default class CreateSlot extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() typeOfDataOptions: any;
    @Prop() printingTypeOptions: any;
    @Prop() endiannessTypeOptions: any;
    @Prop() visibleFrameFromList: any;

    @Prop() currentAction: string;
    @Prop() protocolTypes: any;
    @Prop() patchData: any;
    @Prop() editingEcu: boolean;
    @Prop() tipoVarOptions: any;
    @Prop() slotOptions: any;
    @Prop() unityOptions: any;
    @Prop() editing: boolean;
    @Prop() editingFrame: boolean;
    @Prop() editingParam: boolean;
    visibleCloseConfirmationModal: boolean = false;
    visibleModalCreateSlot: boolean = false;
    slotDescription: string = '';
    pendingRequest: boolean = false;
    submitButtonText: string = '';
    modalTitle: string = '';

    booleanOptions: any = [
        {
            value: true,
            description: 'true'
        },
        {
            value: false,
            description: 'false'
        }
    ];
    //select options
    typeOfDataSelected: any | null = null;
    printingTypeSelected: any | null = null;
    endianessTypeSelected: any | null = null;

    //select reset value
    resetTypeOfDataValue: boolean = false;
    resetPrintingTypeSelected: boolean = false;
    resetEndianessTypeSelected: boolean = false;

    lenght: any = 0;
    order: any = 0;
    coeficients: string = '';
    delimiterchar: string = '';

    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;

    //Breadcrums
    breadcrumsItems: any = [];

    //methods
    mounted() {
        this.handleListenKey(true);
        this.visibleModalCreateSlot = this.visible;

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_VISIBLE, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_FRAMES_DIALOG_VISIBLE, () => {
            this.closeModal();
        });

        if (this.editing) {
            this.submitButtonText = 'Modificar slot';
            this.modalTitle = 'Modificar slot' + ' <b> - ' + this.patchData['description'] + '</b>';
            this.loadPatchData();
        } else {
            this.submitButtonText = 'Crear slot';
            this.modalTitle = 'Crear slot';
        }
    }

    updateDelimiterChar(value){
        this.delimiterchar = value;
    }
    updateSlotDescription(value){
        this.slotDescription = value;
    }
    updateCoeficientsr(value){
        this.coeficients = value;
    }
    updateLength(value){
        this.lenght = value;
    }
    updateOrder(value){
        this.order = value;
    }

    loadPatchData() {
        this.slotDescription = this.patchData['description'];
        let indexEndiannesstype = getIndexFromList(this.endiannessTypeOptions, 'id', this.patchData['endianness_type']);
        let indexPrintingType = getIndexFromList(this.printingTypeOptions, 'id', this.patchData['printing_type']);
        let indexTypeOfData = getIndexFromList(this.typeOfDataOptions, 'id', this.patchData['type_of_data']);
        this.updateEndianessTypeSelected(this.endiannessTypeOptions[indexEndiannesstype]);
        this.updatePrintingTypeSelected(this.printingTypeOptions[indexPrintingType]);
        this.updateTypeOfDataSelected(this.typeOfDataOptions[indexTypeOfData]);
        this.lenght = this.patchData['length'];
        this.order = this.patchData['order'];
        this.coeficients = this.patchData['coeficients'];
        this.delimiterchar = this.patchData['delimiter_char'];
    }

    updateTypeOfDataSelected(option) {
        this.typeOfDataSelected = option;
    }

    updatePrintingTypeSelected(value) {
        this.printingTypeSelected = value;
    }

    updateEndianessTypeSelected(value) {
        this.endianessTypeSelected = value;
    }

    updateTypeOfDataResetValue(value) {
        this.resetTypeOfDataValue = value;
    }

    updatePrintingTypeResetValue(value) {
        this.resetPrintingTypeSelected = value;
    }

    updateEndianessTypeResetValue(value) {
        this.resetEndianessTypeSelected = value;
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
        this.visibilityCloseConfirmationModal(false);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }

    get getBreadcrumsItems() {
        let breadcrumsOptions = [
            {
                text: this.visibleFrameFromList ? 'Listado de Frames' : 'Listado de ECUs',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuList'
            },
            {
                text: !this.editingEcu ? 'Crear Ecu' : 'Modificar ECU',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuDialog'
            },
            {
                text: this.editingFrame ? 'Modificar frame' : 'Crear frame',
                disabled: false,
                href: '',
                active: false,
                action: 'goToFrameDialog'
            },
            {
                text: this.editingParam ? 'Modificar Parámetro' : 'Agregar parámetro',
                disabled: false,
                href: '',
                active: false,
                action: 'back'
            },
            {
                text: this.editing ? 'Modificar Slot' : 'Crear Slot',
                disabled: false,
                href: '',
                active: true,
                action: null
            }
        ];

        if (this.visibleFrameFromList) {
            breadcrumsOptions.splice(1, 1);
        }

        return breadcrumsOptions;
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.pendingRequest = false;
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    triggerSubmit() {
        let self = this;
        this.pendingRequest = true;
        let configuration = this.getData();
        self.scrollToTopOfModal();
        if (!this.editing) {
            self.pendingLoadingDialog('Generando Slot...');
            NormsServices.postCreateSlot(configuration)
                .then(response => {
                    self.successPost = true;
                    self.handleSuccessAction(response);
                    self.pendingRequest = false;
                    self.closeModal();
                    self.$emit('add-new-slot', response['slot']);
                })
                .catch(error => {
                    // console.log("error protocolo", error);
                    self.handleErrorAction(error, 'Ocurrio un error al generar el Slot');
                });
        } else {
            self.pendingLoadingDialog('Modificando Slot...');
            NormsServices.patchSlot(configuration, this.patchData['id'])
                .then(response => {
                    self.successPost = true;
                    self.handleSuccessAction(response['data']);
                    self.pendingRequest = false;
                    self.closeModal();
                    self.$emit('updated-slot', response['data']['slot']);
                })
                .catch(error => {
                    self.handleErrorAction(error, 'Ocurrio un error al modificar el Slot');
                });
        }
    }

    scrollToTopOfModal() {
        $('.dialog-slot').scrollTop(0);
    }

    getData() {
        let baseData = {
            description: this.slotDescription,
            type_of_data: Number(this.typeOfDataSelected['id'])
        };

        let printingTypeValue = this.printingTypeSelected == null ? null : Number(this.printingTypeSelected['id']);
        let endianessTypeValue = this.endianessTypeSelected == null ? null : Number(this.endianessTypeSelected['id']);
        let delimiterChar = isNullOrEmpty(this.delimiterchar) ? '' : this.delimiterchar;
        if (
            this.typeOfDataSelected['id'] !== SlotTypes.FixedLengthASCII &&
            this.typeOfDataSelected['id'] !== SlotTypes.DelimitedASCII &&
            this.typeOfDataSelected['id'] !== SlotTypes.DelimitedASCIIToDecimal &&
            this.typeOfDataSelected['id'] !== SlotTypes.MultiplePartsASCII
        ) {
            this.$set(baseData, 'endianness_type', endianessTypeValue);
            this.$set(baseData, 'order', this.order);
            this.$set(baseData, 'coeficients', this.coeficients);
        }

        if (this.typeOfDataSelected['id'] !== SlotTypes.DelimitedASCII && this.typeOfDataSelected['id'] !== SlotTypes.DelimitedASCIIToDecimal ) {
            this.$set(baseData, 'length', this.lenght);

            if (this.typeOfDataSelected['id'] === SlotTypes.FixedLengthASCII || this.typeOfDataSelected['id'] === SlotTypes.MultiplePartsASCII) {
                this.$set(baseData, 'printing_type', printingTypeValue);
            }
        } else {
            if (this.typeOfDataSelected['id'] === SlotTypes.DelimitedASCII) {
                this.$set(baseData, 'delimiter_char', delimiterChar);
                this.$set(baseData, 'printing_type', printingTypeValue);
            }

            if (this.typeOfDataSelected['id'] === SlotTypes.DelimitedASCIIToDecimal) {
                this.$set(baseData, 'delimiter_char', delimiterChar);
            }
        }

        return baseData;
    }

    get checkIfFormIsValid() {
        if (this.slotDescription !== '' && this.typeOfDataSelected !== null) {
            return true;
        } else {
            return false;
        }
    }

    getFinalizationValue(finalization) {
        if (finalization !== null) {
            if (finalization['id'] !== -1) {
                return finalization['id'];
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getInitializationValue(initialization) {
        if (initialization !== null) {
            if (initialization['id'] !== -1) {
                return initialization;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    get visibilityDelimiterChart() {
        if (this.typeOfDataSelected == null) {
            this.delimiterchar = '';
            return false;
        } else {
            if (this.typeOfDataSelected['id'] === SlotTypes.DelimitedASCII || this.typeOfDataSelected['id'] === SlotTypes.DelimitedASCIIToDecimal) {
                return true;
            } else {
                this.delimiterchar = '';
                return false;
            }
        }
    }

    get visibilityPrintingType() {
        if (this.typeOfDataSelected == null) {
            this.updatePrintingTypeSelected(null);
            return false;
        }

        if (
            this.typeOfDataSelected['id'] === SlotTypes.FixedLengthASCII ||
            this.typeOfDataSelected['id'] === SlotTypes.DelimitedASCII ||
            this.typeOfDataSelected['id'] === SlotTypes.MultiplePartsASCII
        ) {
            return true;
        }
        
        this.updatePrintingTypeSelected(null);
        return false;
    }

    get visibilityRestOfFields() {
        if (this.typeOfDataSelected == null) {
            this.updateEndianessTypeSelected(null);
            this.coeficients = '';
            this.order = 0;

            return false;
        } else {
            if (
                this.typeOfDataSelected['id'] !== SlotTypes.FixedLengthASCII &&
                this.typeOfDataSelected['id'] !== SlotTypes.DelimitedASCII &&
                this.typeOfDataSelected['id'] !== SlotTypes.DelimitedASCIIToDecimal &&
                this.typeOfDataSelected['id'] !== SlotTypes.MultiplePartsASCII
            ) {
                return true;
            } else {
                this.updateEndianessTypeSelected(null);
                this.coeficients = '';
                this.order = 0;
                return false;
            }
        }
    }

    get visibilityLength() {
        if (this.typeOfDataSelected == null) {
            this.lenght = 0;
            return false;
        } else {
            if (
                this.typeOfDataSelected['id'] !== SlotTypes.DelimitedASCII &&
                this.typeOfDataSelected['id'] !== SlotTypes.DelimitedASCIIToDecimal
            ) {
                return true;
            } else {
                this.lenght = 0;
                return false;
            }
        }
    }
}
